import AddonDiscovery, { Utils } from "./AddonDiscovery";
export default AddonDiscovery;
export const AddonDiscoveryUtils = Utils;
export { TelemetryTasks as AddonDiscoveryTelemetry, cloudFortifiedFilter } from "./AddonDiscovery";
export { default as AnalyticsEvents } from "./AddonDiscovery/constants/analytics/events"; // This isn't at the right abstraction level to be used externally, and using a collection
// of hits is recommended instead when possible. Use with caution.

export { default as DangerouslyUseResponsiveHit } from "./common/components/Hits/ResponsiveHit";
export { getFilters } from "./common/config/filters";
export { default as FacetType } from "./common/records/FacetType";
export { FeaturedAddonsConfig } from "./common/records/FeaturedAddonsConfig";
export { default as FeaturedContentOverride } from "./common/records/FeaturedContentOverride";
export { default as HitRecord } from "./common/records/Hit";
export { default as SearchParamsUpdate } from "./common/records/SearchParamsUpdate";
export { getAppDetailsByAppKeys } from "./common/utils/algolia";
export { resolveHits } from "./common/utils/algoliaProcessors";
export { default as Hits } from "./Hits";
export { default as HitsCollection } from "./HitsCollection";
export { default as Recommendations } from "./Recommendations";
export { HitsType } from "./Recommendations/recommendation.types";
export { default as StaticSearch } from "./StaticSearch";